import { array, boolean, intersect, number, partial, string, struct } from 'io-ts/Decoder';

import { Area } from '../../../../ui/geometry/Area';

export const Request = intersect(
	struct({
		text: string,
		areas: array(Area),
	})
)(
	partial({
		number: number,
		internal: boolean,
	})
);
